module.exports = __webpack_public_path__ + "static/media/Popup_BedLight.e799c749.png";